import { render, staticRenderFns } from "./LinkLeadsDialog.vue?vue&type=template&id=3ae4fecc&scoped=true&"
import script from "./LinkLeadsDialog.vue?vue&type=script&lang=js&"
export * from "./LinkLeadsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinkLeadsDialog.vue?vue&type=style&index=0&id=3ae4fecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4fecc",
  null
  
)

export default component.exports